import { Component, ViewChild, ElementRef } from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { HttpCustomerService } from '../../../../service/httpcustomer.service';
import { CommonService } from '../../../../service/common.service';
import { WebParameterContext } from '../../../../model/common';
import { AppPageElementType } from '../../../../model/xmlconfig/app.page.element.type';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { PlatformLocation} from '@angular/common';
declare var echarts;//设置echarts全局对象
declare var app;
@Component({
  selector: 'app-mz-head-pg',
  templateUrl: './mz-head-pg.component.html',
  styleUrls: ['./mz-head-pg.component.scss']
})
export class MzHeadPgComponent extends GridBaseCase {
  dataArrayList: any = { visit: { value: 0, text: "暂无数据" }, work: { value: 0, text: "暂无数据" }, store: { value: '', text: "暂无数据" }, Way: { value: 0, text: "暂无数据" }, today: { value: 0, text: "暂无数据" }, date: { value: '', text: '暂无数据' }, time: { value: '', text: '暂无数据' } };
  buttonArr: any = null;
  signInfo: any = [];
  constructor(
    public com: CommonService,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private msg: MessageclientService,
    private router: Router,
    private platformlocation:PlatformLocation
  ) {
    super();

  }

  //@ViewChild('echartsContent') container: ElementRef;//与html中div #container1对应
  // @ViewChild('echartsContent2') container2: ElementRef;//与html中div #container1对应
  //EChart: any;

  // echart2: any;
  ngOnInit() {
    const that = this;
    that.buttonArr = [];
    if (that.config.length > 0) {
      that.config.forEach((ele) => {
        if (ele.type.toString().toLocaleLowerCase() == "head_pg") {
          that.element = ele;
        } else if (ele.type.toString().toLocaleLowerCase() == "button_link1") {
          // that.LoadData2(ele);
          // that.buttonArr.push(ele);
        }
      })
    }
    that.LoadData();

  }
  LoadData() {
    const that = this;
    // that.LoadData1();//
    // console.log("1008611");
    const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const types = that.activaRouter.snapshot.paramMap.get('type');
    let  id:any =null;
    if(that.activaRouter.snapshot.paramMap.get('id')){
      id = that.activaRouter.snapshot.paramMap.get('id').split('&')[0];
    }
    if (that.element.selectItemList.selectItem.length > 0) {
      let body: WebParameterContext = new WebParameterContext();
      if (that.element.selectItemList.gridViewConfigName) {
        body.ConfigName = that.element.selectItemList.gridViewConfigName;
      }
      body.OpType = "query";
      body.ConfigType = "view";
      body.Client.PageName = pageName;
      if(that.com.GetStorageKey("pginfo")){
        body.RequestBody = JSON.stringify({"a_ID":that.com.GetStorageKey("pginfo")["a_ID"]});
      }else{
        body.RequestBody = JSON.stringify({"a_FK_SystemUser_ID":that.com.GetAccount.Id,"a_SNState":1,"a_SNStartDate":that.com.BetweenDate(that.com.getNow+" 00:00:00",that.com.getNow+" 23:59:59")});
      }
      that.http.post(app.DEFAULTURL, body).then(data => {
        if (data.ResponseMessage.Success) {
          let objfield = {};
          if (data.Status.Datas.length > 0) {
            data.Status.Datas.forEach(function (item) {
              that.element.selectItemList.selectItem.forEach((element, index) => {
                if (element.bindingField) {
                  objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
                }
              });
            });
            //保存门店信息
            if(objfield["fk_store_id"]){
              console.log(1001011);
              localStorage.setItem("tbstore",JSON.stringify({"ID":objfield["fk_store_id"].value}));
            }
            //console.log(objfield);
            that.dataArrayList = objfield;
            if(this.dataArrayList["indate"].value !=null){//表示上班
                localStorage.setItem("pgindata","1");
            }else{
              localStorage.removeItem("pgindata");
            }
            if(this.dataArrayList["ondate"].value !=null){//表示下班
              localStorage.setItem("pgondate","1");
            }else{
              localStorage.removeItem("pgondate");
            }
          }

        } else {
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
      });
    }
  }
  /**
   * 调转链接
   * @param ev url
   */
  EventLink(ev) {
    let evs = ev.url || '';
    if (evs.trim()) {
      if (evs.indexOf("http") > 0) {
        this.com.goWebPage(evs, "");
      } else {
        this.com.Go(evs);
      }
    } else {
      this.msg.Show("暂未开通", "middle");
    }
  }
  /**
   * 操作
   * @param n 
   */
  gohome(n){
    const id = this.dataArrayList["ID"].value;
  //console.log(101011);
    if(id){
      if(n==1){
        if(this.dataArrayList["indate"].value ==null){
          let location:any = {"lng":0,"lat":0,"date":0};
          if(this.dataArrayList.lng.value && this.dataArrayList.lat.value)
          {
            location["lng"]=this.dataArrayList.lng.value;//门店坐标
            location["lat"]=this.dataArrayList.lat.value;//门店
          
            // location = JSON.stringify({"lng":this.dataArrayList.lng.value,"lat":this.dataArrayList.lat.value,"date":this.dataArrayList["snstartdate"].value});
          }
          location["date"]=this.dataArrayList["snstartdate"].value;//下班时间
          // localStorage.setItem("mapmun",location);
          
          let getRow = escape(JSON.stringify(location));
          // console.log(getRow);
          if(this.platformlocation["location"].hash.replace('#','')){
            //localStorage.setItem("backurl",this.platformlocation["location"].hash.replace('#',''));
          this.com.setHistoryUrl();
          }
           this.com.Go("/tabs/contact/ClockIn/add/"+id+"&"+getRow);
           
        }else{
          this.msg.Show("已上班");
        }
       
      }else if(n==2){
       if(this.dataArrayList["indate"].value ==null){
         this.msg.Alert("请先上班");
       }else{
        if(this.dataArrayList["ondate"].value){
          this.msg.Show("下班操作排面无效");
        }else{
          if(this.platformlocation["location"].hash.replace('#','')){
            //localStorage.setItem("backurl",this.platformlocation["location"].hash.replace('#',''));
            this.com.setHistoryUrl();
          }
          const status = this.dataArrayList['normal'].value || "未排面";
          this.com.Go("/tabs/contact/DepartureReport/add/"+id + "&" + encodeURIComponent(status));
        }
       }
      }else if(n==3){
        if(this.dataArrayList["indate"].value==null){
          this.msg.Alert("请先上班");
        }else{
          if(this.dataArrayList["ondate"].value ==null){
            let location:any = {"lng":0,"lat":0};
            if(this.dataArrayList.lng.value && this.dataArrayList.lat.value)
            {
              location["lng"]=this.dataArrayList.lng.value;//门店坐标
              location["lat"]=this.dataArrayList.lat.value;//门店
              // location = JSON.stringify({"lng":this.dataArrayList.lng.value,"lat":this.dataArrayList.lat.value,"date":this.dataArrayList["snstartdate"].value,"inlng":this.dataArrayList.startlog,"inlat":this.dataArrayList.startlat,"stat":1});
            }
              location["date"]=this.dataArrayList["snenddate"].value;//下班时间
              location["inlng"] = this.dataArrayList.startlog;//进店坐标
              location["inlat"] = this.dataArrayList.startlat;//进店坐标
              location["stat"] =  this.dataArrayList.workstate;//上班状态;
            let getrow = escape(JSON.stringify(location));
             localStorage.setItem("mapmun",location);
             if(this.platformlocation["location"].hash.replace('#','')){
              //localStorage.setItem("backurl",this.platformlocation["location"].hash.replace('#',''));
              this.com.setHistoryUrl();
            }
             this.com.Go("/tabs/contact/ClockOut/add/"+id+"&"+getrow);
          }else{
            this.msg.Show("已下班");
          }
        
        }
       
      }
    }else{

      this.msg.Alert("排班有误，请联系管理员");
    }


  }
  LoadData1() {
    const that = this;
    that.buttonArr = [];
    if (that.config.length > 0) {
      that.config.forEach((ele) => {
        if (ele.type.toString().toLocaleLowerCase() == "button_link1") {
          that.LoadData2(ele);
          that.buttonArr.push(ele);
        }
      })
    }
  }

  LoadData2(ele) {
    const that = this;
    const pageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const types = that.activaRouter.snapshot.paramMap.get('type');
    const id = that.activaRouter.snapshot.paramMap.get('id');
    if (ele.selectItemList.selectItem.length > 0) {
      let body: WebParameterContext = new WebParameterContext();
      if (ele.selectItemList.gridViewConfigName) {
        body.ConfigName = ele.selectItemList.gridViewConfigName;
      }
      body.OpType = "query";
      body.ConfigType = "view";
      body.Client.PageName = pageName;
      // body.RequestBody = JSON.stringify({"a_ID":id});
      that.http.post(app.DEFAULTURL, body).then(data => {
        if (data.ResponseMessage.Success) {
          that.apiObj['status'] = true;
          that.loading = true;
          let objfield = {};
          if (data.Status.Datas.length > 0) {
            data.Status.Datas.forEach(function (item) {
              ele.selectItemList.selectItem.forEach((element, index) => {
                if (element.bindingField) {
                  objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
                }
              });
            });
            that.signInfo.push(objfield);
          }

        } else {
          that.apiObj['status'] = false;
          that.loading = true;
          that.msg.Alert(data.ResponseMessage.ErrorMessage);
        }
      }).catch(error => {
        that.apiObj['status'] = false;
        that.loading = true;
        that.msg.Alert(error.ResponseMessage.ErrorMessage);
      });
    }
  }


}

